import { lazy, memo, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { RouteMapping } from "layout/App/mapping";
import withTracker from "util/withTracker";

interface SubRouteLayoutProps {
  mapping: RouteMapping;
}
const NotFound = lazy(() => import("pages/NotFound/index"));

const SubRouteLayout = memo(({ mapping }: SubRouteLayoutProps) => {
  const availableRoutes = Object.keys(mapping.components);

  return (
    <Suspense fallback={null}>
      <Routes>
        {availableRoutes.map((route) => {
          const Component = mapping.components[route];
          return <Route key={route} path={route} element={<Component />} />;
        })}
        {/* 404 for unmatched nested routes */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
});

export default withTracker(SubRouteLayout);
